var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

import { isFunction } from './util';

var fromFn = function fromFn(type, withFields) {
  return function (values) {
    return _extends({}, withFields.apply(undefined, _toConsumableArray(values)), {
      type: type
    });
  };
};

var makeField = function makeField(values) {
  return function (action, field, index) {
    return _extends(_defineProperty({}, field, values[index]), action);
  };
};

var fromArr = function fromArr(type, fields) {
  return function (values) {
    return fields.reduce(makeField(values), {
      type: type
    });
  };
};

var makeConstructor = function makeConstructor(type, withFields) {
  return isFunction(withFields) ? fromFn(type, withFields) : fromArr(type, withFields);
};

export function toCreator(type) {
  var withFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var constructor = makeConstructor(type, withFields);
  return function actionCreator() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return constructor(args);
  };
}